import {
    SupervisionOrder,
    SupervisionOrderFilter
} from '@idea2app/ai-work-order-service';

import { TableModel } from './Base';
import userStore from './User';

export class SupervisionOrderModel extends TableModel<
    SupervisionOrder,
    SupervisionOrderFilter
> {
    baseURI = 'work-order/pending-supervision';
    client = userStore.client;
}

export default new SupervisionOrderModel();
